import { useState, type FormEvent } from "react";
import Check from "~icons/ph/check";
import { usernameCooldownMs } from "../../shared/api";
import type { Person } from "../../shared/types";
import { dateTime, t } from "../i18n";
import { useNow } from "../ui/use-now";

export function ProfileEditor({
  person,
  disabled,
  error,
  onSave,
}: {
  person: Person;
  disabled: boolean;
  error: string;
  onSave: (changes: { name: string; username: string; bio: string }) => void;
}) {
  const [name, setName] = useState(person.name);
  const [username, setUsername] = useState(person.username);
  const [bio, setBio] = useState(person.bio ?? "");
  const unlocksAt = (person.username_changed_at ?? 0) + usernameCooldownMs;
  const locked = unlocksAt > useNow();
  function submit(event: FormEvent) {
    event.preventDefault();
    onSave({ name, username, bio });
  }
  return (
    <>
      <h2>{t("تعديل الحساب")}</h2>
      <p className="modal-description">
        {t("يراه أصدقاؤك ومن يجد حسابك باسم المستخدم أو برابطه.")}
      </p>
      <form onSubmit={submit}>
        <label>
          {t("اسمك")}{" "}
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            minLength={2}
            maxLength={40}
            required
            autoComplete="nickname"
          />
        </label>
        <label>
          {t("اسم المستخدم")}{" "}
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
            aria-label={t("اسم المستخدم")}
            aria-describedby="username-help"
            pattern="[a-z0-9_]{3,24}"
            minLength={3}
            maxLength={24}
            required
            disabled={locked}
            dir="ltr"
            autoComplete="off"
          />
          <small id="username-help" className="field-help">
            {locked
              ? t("يمكنك تغيير اسم المستخدم مجددًا بعد {date}.", {
                  date: dateTime(unlocksAt),
                })
              : t("يمكن تغييره مرة واحدة كل ٢٤ ساعة.")}
          </small>
        </label>
        <label>
          {t("نبذة عنك")}{" "}
          <input
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            maxLength={100}
            dir="auto"
          />
        </label>
        {error && (
          <p className="form-error" role="alert">
            {t(error)}
          </p>
        )}
        <button className="button full" disabled={disabled}>
          {t("حفظ التغييرات")} <Check width={16} height={16} />
        </button>
      </form>
    </>
  );
}
